import "bootstrap/dist/css/bootstrap.min.css";
import {Box} from '@mui/material';
import {useLanguage} from "../LanguageContext";
import PageHeader from "../components/PageHeader";

import image3 from "../images/tours/tst-img3.jpg";
import {PageTitle} from "../components/PageTitle";
import React, {useEffect} from "react";
import ReactGA from "react-ga4";

const images = [
    image3,
];


const WayToExplorePage = () => {
    const {t} = useLanguage();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    }, []);

    return (
        <Box>
            <PageTitle title={'label_way_to_explore'}/>
            <Box
                sx={{
                    backgroundColor: "#f0f0f0"
                }}
            >
                <PageHeader color={'#f0f0f0'} images={images}
                            content={{
                                title: 'way_title',
                                // subtitle:'way_subtitle'
                            }}
                />

                {/* Section with text on the left and photo on the right */}
                {/*<Container sx={{my: 4}}>*/}
                {/*    <Grid container spacing={4} alignItems="center">*/}
                {/*        <Grid*/}
                {/*            item*/}
                {/*            xs={12}*/}
                {/*            md={6}*/}
                {/*            sx={{*/}
                {/*                display: "flex",*/}
                {/*                flexDirection: "column",*/}
                {/*                justifyContent: "center",*/}
                {/*                alignItems: "center",*/}
                {/*                textAlign: {xs: "center", md: "left"}, // Center text on small screens*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            <Typography variant="h4Black"*/}
                {/*                        sx={{}}*/}
                {/*                        gutterBottom>*/}
                {/*                Private Tours*/}
                {/*            </Typography>*/}
                {/*            <Typography variant="body1">*/}
                {/*                For a truly personalised experience, our private tours are the perfect choice. Whether*/}
                {/*                you’re travelling with friends, celebrating a special occasion like a birthday, hen or*/}
                {/*                stag party, enjoying a family getaway, or planning any kind of unique adventure, we’ll*/}
                {/*                create the ideal trip for you.*/}
                {/*            </Typography>*/}

                {/*            <Typography*/}
                {/*                sx={{*/}
                {/*                    marginTop: '8px',*/}
                {/*                }}*/}
                {/*                variant="body1">*/}
                {/*                Simply tell us what you’re looking for, and we’ll handle the rest. From choosing the*/}
                {/*                perfect destination to planning every detail, your private tour is designed around your*/}
                {/*                needs and desires. With complete flexibility, privacy, and an itinerary that suits you,*/}
                {/*                your next adventure is only a flight away.*/}
                {/*            </Typography>*/}
                {/*        </Grid>*/}
                {/*        <Grid item xs={12} md={6}>*/}
                {/*            <Box*/}
                {/*                sx={{*/}
                {/*                    display: "flex",*/}
                {/*                    flexDirection: "column",*/}
                {/*                    justifyContent: "center",*/}
                {/*                    alignItems: "center",*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                <Box*/}
                {/*                    component="img"*/}
                {/*                    src={me}*/}
                {/*                    alt="Right Section Photo"*/}
                {/*                    sx={{*/}
                {/*                        width: "auto",*/}
                {/*                        maxHeight: '500px',*/}
                {/*                        borderRadius: "8px",*/}
                {/*                        boxShadow: 3,*/}
                {/*                    }}*/}
                {/*                />*/}
                {/*            </Box>*/}

                {/*        </Grid>*/}
                {/*    </Grid>*/}
                {/*</Container>*/}

                {/*<Box*/}
                {/*    sx={{*/}
                {/*        backgroundColor: "#f0f0f0",*/}
                {/*        alignItems: "center",*/}
                {/*        justifyContent: "center",*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <PrivateToursSection/>*/}
                {/*    <PrivateTourGallerySection/>*/}
                {/*</Box>*/}
                {/*<ContactSection/>*/}
            </Box>
        </Box>
    );
}

export default WayToExplorePage;
